<!-- Renderless: (re)loads the Programs map layers on each map visit, once config data says whether Programs is on. -->
<script lang="ts">
	import { geodataStore } from '#lib/stores/geodataStore.svelte.js';
	import { programsMapStore } from './programsMapStore.svelte';

	$effect(() => {
		if (geodataStore.configDataReady) void programsMapStore.load(geodataStore.configData);
	});
</script>
